// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__HBu4y","actions":"GroupTable_actions__2iYz2","deleteModalFooter":"GroupTable_deleteModalFooter__1HD88"};